import * as types from './types';
import { loading } from 'State/actions';

export const getAccuclaimEditReport = data => {
  return async (dispatch, getState, MPWWebAPI) => {
    dispatch(loading(types.ACCUCLAIM_EDIT_LOADING, true));

    try {
      const response = await MPWWebAPI.postGenericInsertUpdate(
        'Reports/AccuclaimEdit',
        data
      );
      dispatch({
        type: types.ACCUCLAIM_EDIT_GET_REPORT,
        payload: response.data.Data ? response.data.Data : 'No Data',
      });
    } catch (error) {
      dispatch({
        type: types.ACCUCLAIM_EDIT_LOAD_ERROR,
        errors: error.response.Errors,
      });
    }

    dispatch(loading(types.ACCUCLAIM_EDIT_LOADING, false));
  };
};

export const clearReport = () => {
  return {
    type: types.ACCUCLAIM_EDIT_GET_REPORT,
    payload: null,
  };
};

export const setSelectedSites = selectedSites => {
  return async dispatch => {
    return dispatch({
      type: types.ACCUCLAIM_EDIT_SET_SELECTED_SITES,
      payload: selectedSites,
    });
  };
};



// WEBPACK FOOTER //
// ./src/pages/accuclaimedit/state/report/actions.js